import InitialMetaStore, {IMetaStore} from "./meta/InitialMetaStore";
import InitialAuthStore, {IAuthStore} from "./auth/InitialAuthStore";
import InitialAffiliateStore, {IAffiliateStore} from "./affiliateReferrals/InitialAffiliateStore";
import InitialRttrStore, {IRttrStore} from "./rttr/InitialRttrStore";

export interface IStore {
    metaStore: IMetaStore;
    authStore: IAuthStore;
    affiliateStore: IAffiliateStore;
    rttrStore: IRttrStore;
}

export default {
    metaStore: InitialMetaStore,
    authStore: InitialAuthStore,
    affiliateStore: InitialAffiliateStore,
    rttrStore: InitialRttrStore,
} as IStore;
